module.exports = __webpack_public_path__ + "static/job-banner2-1d2085625af7a454538d921b61e6b054.png";